import { Box, Card, Icon, Paragraph, Text } from '@zillow/constellation-10';
import {
  IconMessageOutline,
  IconReplyFilled,
  IconThumbsUpOutline,
  IconZillowMarkLegacy,
} from '@zillow/constellation-icons';

import { FacebookAdPreviewCarousel } from './FacebookAdPreviewCarousel';
import { ZillowAvatarImage } from './ZillowAvatarImage';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const PreviewButtonsContainer = styled('div', {
  base: {
    margin: '-400',
    marginTop: 0,
    color: 'text.onImpact.neutral',
    display: 'flex',
    '& > div': {
      padding: '12px 16px',
      flexGrow: 1,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& span': {
      display: 'inline-block',
      marginLeft: '200',
    },
    '& > div:nth-child(3) svg': {
      transform: 'rotateY(180deg)',
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const StyledText = styled(Text, {
  base: {
    lineHeight: 1,
  },
});

export const FacebookPostPreview = ({
  previewImages,
  address,
  title,
  description,
}: {
  previewImages: Array<string>;
  address: string;
  title: string;
  description: string;
}) => (
  <Card elevated={false}>
    <Box css={{ display: 'flex', alignItems: 'center', marginBottom: '400' }}>
      <Box css={{ marginRight: '400' }}>
        <ZillowAvatarImage size={40}>
          {/* oxlint-disable-next-line constellation/no-raw-color-values */}
          <Icon css={{ color: 'white' }} size="md">
            <IconZillowMarkLegacy />
          </Icon>
        </ZillowAvatarImage>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <StyledText css={{ marginBottom: '100' }}>Zillow - Apartments</StyledText>
        <StyledText
          textStyle="body-sm-bold"
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
        >
          Sponsored
        </StyledText>
      </Box>
    </Box>
    <Paragraph css={{ marginBottom: '400' }}>{description}</Paragraph>
    <FacebookAdPreviewCarousel previewImages={previewImages} address={address} title={title} />
    <PreviewButtonsContainer>
      <Box>
        <Icon
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
          size="md"
        >
          <IconThumbsUpOutline />
        </Icon>
        <Text
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
        >
          Like
        </Text>
      </Box>
      <Box>
        <Icon
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
          size="md"
        >
          <IconMessageOutline />
        </Icon>
        <Text
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
        >
          Comment
        </Text>
      </Box>
      <Box>
        <Icon
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
          size="md"
        >
          <IconReplyFilled />
        </Icon>
        <Text
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
        >
          Share
        </Text>
      </Box>
    </PreviewButtonsContainer>
  </Card>
);
